import * as React from "react";
import Popover from "@mui/material/Popover";
import { IconButton, Stack } from "@mui/material";
import MDTypography from "components/MDTypography";
import { useState } from "react";
import moment from "moment/moment";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useSelector } from "react-redux";
import { COMPETITION_WIN_CONDITIONS } from "lib/constants";
import { getWinConditionDescription } from "utils/HelperFunctions";

function CompetitionInfoPopover({ competition }) {
  const loginUser = useSelector((state) => state.loginUser.loginUserState);
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <IconButton sx={{ mr: 1 }} onClick={handlePopoverOpen}>
        <InfoOutlinedIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        className="competition-info-popover"
        onClick={(event) => event.stopPropagation()}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Stack spacing={1} p={2}>
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">Win condition</MDTypography>
            <MDTypography className="value">{competition?.winCondition || "-"}</MDTypography>
          </Stack>
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">How to win</MDTypography>
            <MDTypography sx={{ maxWidth: "18rem", textAlign: "right" }} className="value">
              {getWinConditionDescription(competition?.winCondition, competition.endDatetime)}
            </MDTypography>
          </Stack>

          {COMPETITION_WIN_CONDITIONS.FIRST_TO_KPI_TARGET === competition?.winCondition && (
            <Stack spacing={2} direction="row" justifyContent="space-between">
              <MDTypography className="title">KPI target</MDTypography>
              <MDTypography className="value">{competition?.target || "-"}</MDTypography>
            </Stack>
          )}
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">Start time</MDTypography>
            <MDTypography className="value">
              {moment
                .tz(competition.startDatetime, loginUser.timezone)
                .format("dddd MMMM D, hh:mm a")}
            </MDTypography>
          </Stack>
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">End time</MDTypography>
            <MDTypography className="value">
              {competition.endDatetime
                ? moment
                    .tz(competition.endDatetime, loginUser.timezone)
                    .format("dddd MMMM D, hh:mm a")
                : "-"}
            </MDTypography>
          </Stack>
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">Created by</MDTypography>
            <MDTypography className="value">{competition.createdByUser}</MDTypography>
          </Stack>
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">Type</MDTypography>
            <MDTypography className="value">
              {competition.type === "tremendous payout" ? "Tremendous Payout" : "Unranked"}
            </MDTypography>
          </Stack>
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <MDTypography className="title">Open to join</MDTypography>
            <MDTypography className="value">{competition.joinable ? "Yes" : "No"}</MDTypography>
          </Stack>
        </Stack>
      </Popover>
    </>
  );
}

export default CompetitionInfoPopover;
